<h1 mat-dialog-title>
  {{ 'properties.dialog.expireContractTitle' | translate }} {{ barCode }}
</h1>
<mat-dialog-content>
  <app-card-spinner [visible]="dialogIsLoading" type="zero"></app-card-spinner>

  <table class="table table-borderless table-striped">
    <thead>
      <th></th>
      <th>{{ 'properties.documentsPage.docType' | translate }}</th>
      <th>{{ 'properties.structures.structure' | translate }}</th>
    </thead>
    <tbody>
      <tr *ngFor="let doc of docs">
        <td>
          <mat-checkbox [checked]="doc.checked"
            (change)="onDocSelected(doc, $event.checked)" class="checkbox-insert">
          </mat-checkbox>
        </td>
        <td>
          {{ doc.docTitle }}
        </td>
        <td>
          {{ doc.structureObjectName }}
        </td>
      </tr>
    </tbody>
  </table>

  <div class="form-wrapper mt-1 mb-3 ml-3">
    {{ 'properties.dialog.contractExpire' | translate }}
  </div> <!-- /.form-wrapper -->
</mat-dialog-content> <!-- mat-dialog-content -->
<div class="col-12 pb-4" mat-dialog-actions>
  <div class="col-6 text-left">
    <div class="w-100">
      <a mat-button (click)="onClose()" mat-raised-button mat-default
        class="ml-3">{{ 'common.cta.close' | translate }}</a>
    </div>
  </div>
  <div class="col-6 text-right" *ngIf="selectedDocs.length">
    <mat-spinner-button (btnClick)="onFormSubmit()" role="submit" [options]="formBtnOptions" class="btn-elevate">
    </mat-spinner-button>
  </div>
</div>